import { totpAccessoSchema } from '@aulaviva/shared';
import { Alert, Button, OtpField, PageHeading } from '@aulaviva/ui';
import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { useAccessoTotp } from '@/api/auth';
import { ErroreRichiesta } from '@/api/client';
import { homePerRuolo } from '@/lib/ruoli';
import { sicurezza } from '@/testi';

type Input = { email: string; codice: string };

/** Secondo passo dell'accesso per gli amministratori: codice dell'app di autenticazione. */
export function CodiceAutenticazione() {
  const t = sicurezza.codiceAutenticazione;
  const [params] = useSearchParams();
  const email = params.get('email') ?? '';
  const dopo = params.get('dopo');
  const navigate = useNavigate();
  const accesso = useAccessoTotp();
  const [errore, setErrore] = useState<string | null>(null);
  const { control, register, handleSubmit, formState } = useForm<Input>({ resolver: zodResolver(totpAccessoSchema), defaultValues: { email, codice: '' } });

  async function invia(dati: Input) {
    setErrore(null);
    try {
      const { utente } = await accesso.mutateAsync(dati);
      navigate(dopo ?? homePerRuolo(utente.ruolo), { replace: true });
    } catch (e) {
      if (e instanceof ErroreRichiesta && e.status === 429) setErrore(t.bloccato);
      else if (e instanceof ErroreRichiesta && e.codice === 'presessione_scaduta') setErrore(t.scaduta);
      else if (e instanceof ErroreRichiesta && (e.status === 400 || e.status === 401)) setErrore(t.errato);
      else setErrore(e instanceof Error ? e.message : t.errato);
    }
  }

  if (!email) {
    return (
      <>
        <PageHeading>{t.titolo}</PageHeading>
        <Alert variant="warning" title={t.emailMancante}>
          <Link to="/accedi">{t.tornaAllAccesso}</Link>
        </Alert>
      </>
    );
  }

  return (
    <>
      <PageHeading subtitle={t.sottotitolo(email)}>{t.titolo}</PageHeading>
      <form onSubmit={handleSubmit(invia)} noValidate className="flex flex-col gap-6">
        {errore && <Alert variant="error" title={errore} />}
        <input type="hidden" {...register('email')} />
        <Controller
          control={control}
          name="codice"
          render={({ field }) => <OtpField label={t.campo} hint={t.aiuto} value={field.value} onChange={field.onChange} onBlur={field.onBlur} error={formState.errors.codice?.message} />}
        />
        <Button type="submit" variant="primary" size="lg" fullWidth loading={accesso.isPending} loadingText={t.inCorso}>
          {t.azione}
        </Button>
      </form>
      <p className="t-body text-ink-muted">
        <Link to="/accedi">{t.tornaAllAccesso}</Link>
      </p>
    </>
  );
}
